<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4>Manifesto de Produtos XML</h4>
          </div>
          <div class="card-body">
            <!-- Upload de arquivo XML -->
            <div class="row mb-3">
              <div class="col-md-12">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <input
                      type="file"
                      id="fileInput"
                      accept=".xml"
                      style="display: none"
                      @change="handleFileChange"
                    />
                    <button class="btn btn-info" @click="selecionarArquivo()">
                      <i class="bx ri-file-upload-line"></i> Selecionar Arquivo XML
                    </button>
                  </div>
                  <div>
                    <button class="btn btn-secondary" @click="limparProdutos" v-if="produtos_xml.length > 0">
                      <i class="bx ri-delete-bin-line"></i> Limpar
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Resumo dos produtos -->
            <div v-if="produtos_xml.length > 0" class="row mb-3">
              <div class="col-md-12">
                <div class="card bg-light">
                  <div class="card-body">
                    <div class="row text-center">
                      <div class="col-md-2">
                        <h5 class="text-primary">{{ produtos_xml.length }}</h5>
                        <small>Total</small>
                      </div>
                      <div class="col-md-2">
                        <h5 class="text-success">{{ getProdutosPorStatus('existente').length }}</h5>
                        <small>Relacionados</small>
                      </div>
                      <div class="col-md-2">
                        <h5 class="text-warning">{{ getProdutosPorStatus('novo').length }}</h5>
                        <small>Novos</small>
                      </div>
                      <div class="col-md-2">
                        <h5 class="text-info">{{ getProdutosPorStatus('salvo').length }}</h5>
                        <small>Salvos</small>
                      </div>
                      <div class="col-md-2">
                        <h5 class="text-secondary">{{ getProdutosPorStatus('novo').length }}</h5>
                        <small>Serão Criados</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tabela de produtos -->
            <div v-if="produtos_xml.length > 0">
              <b-table
                id="produtos-xml-table"
                bordered
                hover
                :items="produtos_xml"
                :fields="fields_produtos_xml"
                responsive
              >
                <template #cell(cod_fornec)="row">
                  <div>
                    <b-badge variant="primary">
                      {{ row.item.cod_fornec }}
                    </b-badge>
                  </div>
                </template>
                <template #cell(nome_fornecedor)="row">
                  <div>
                    <b-badge variant="info">
                      {{ row.item.nome_fornecedor }}
                    </b-badge>
                  </div>
                </template>
                <template #cell(cod_empresa)="row">
                  <div>
                    <b-form-input 
                      v-model="row.item.cod_empresa" 
                      placeholder="Código na empresa"
                      size="sm"
                      class="text-right"
                    ></b-form-input>
                  </div>
                </template>
                <template #cell(nome_empresa)="row">
                  <div>
                    <b-form-input 
                      :class="row.item.cod_empresa.replace(/\./g, '')+'-nome_empresa'"
                      v-model="row.item.nome_empresa" 
                      placeholder="Nome na empresa"
                      size="sm"
                    ></b-form-input>
                  </div>
                </template>
                <template #cell(fator_conv)="row">
                  <div>
                    <b-form-input 
                      v-model="row.item.fator_conv" 
                      placeholder="Fator conversão"
                      type="number"
                      step="0.01"
                      size="sm"
                      class="text-right"
                    ></b-form-input>
                  </div>
                </template>
                <template #cell(unidade_fornecedor)="row">
                  <div>
                    <b-badge variant="secondary">
                      {{ row.item.unidade_fornecedor || '-' }}
                    </b-badge>
                  </div>
                </template>
                <template #cell(status)="row">
                  <div>
                    <b-badge 
                      :variant="getStatusVariant(row.item.status)"
                      :title="getStatusTitle(row.item.status)"
                    >
                      {{ getStatusText(row.item.status) }}
                    </b-badge>
                  </div>
                </template>
                <template #cell(acoes)="row">
                  <div>
                    <b-button 
                      size="sm" 
                      variant="warning" 
                      @click="editarImpostos(row.item)"
                      title="Alterar impostos do produto"
                    >
                      <i class="bx ri-edit-line"></i> Alterar
                    </b-button>
                  </div>
                </template>
              </b-table>
              
              <!-- Botões de ação para os produtos -->
              <div class="row mt-3">
                <div class="col-md-12 text-center">
                  <button v-if="false" class="btn btn-primary me-2" @click="processarProdutos()" :disabled="getProdutosPorStatus('novo').length === 0">
                    <i class="bx ri-search-line"></i> Processar Produtos
                    <span v-if="getProdutosPorStatus('novo').length > 0" class="badge bg-light text-dark ms-1">
                      {{ getProdutosPorStatus('novo').length }}
                    </span>
                  </button>
                  <button class="btn btn-success me-2" @click="salvarRelacionamentos()" :disabled="getProdutosPorStatus('existente').length === 0 && getProdutosPorStatus('novo').length === 0">
                    <i class="bx ri-save-line"></i> Enviar Arquivo XML
                    <span v-if="getProdutosPorStatus('existente').length > 0 || getProdutosPorStatus('novo').length > 0" class="badge bg-light text-dark ms-1">
                      {{ getProdutosPorStatus('existente').length + getProdutosPorStatus('novo').length }}
                    </span>
                  </button>
                  <button class="btn btn-info" @click="limparProdutos()">
                    <i class="bx ri-refresh-line"></i> Limpar
                  </button>
                </div>
              </div>
            </div>

            <!-- Componente para edição de impostos -->
            <edit-tax
              :produto="produtoEditando"
              :visible="!!produtoEditando"
              :list-grupos="listGrupos"
              :configuracao-empresa="configuracaoEmpresa"
              @salvar="salvarImpostos"
              @cancelar="cancelarEdicaoImpostos"
              @hidden="onModalHidden"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PessoaController from "@/controller/PessoaController";
import ProdutoController from "@/controller/ProdutoController";
import PedidoManifestoController from "@/controller/PedidoManifestoController";
import ProdutoManifestoService from "@/services/ProdutoManifestoService";
import NotificationService from "@/services/NotificationService";
import EditTax from "@/components/edit_tax.vue";
import { listEstados } from "@/components/defaults/estados.js";

export default {
  name: "Manifesto",
  components: {
    EditTax
  },
  props: {
    abrir: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      abrir1: false,
      currentEmpresa: null,
      currentUser: null,
      produtos_vet: [],
      pessoas_vet: [],
      files_array: [],
      files_array_get: [],
      vetor_new_pre_nfe: [],
      upload_bool: false,
      boll_arquivos: false,
      fields_produtos_xml: [
        {
          label: "Cod Fornec.",
          key: "cod_fornec",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Nome do Fornecedor",
          key: "nome_fornecedor",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Cód na Empresa",
          key: "cod_empresa",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Nome na Empresa",
          key: "nome_empresa",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Fator Conv.",
          key: "fator_conv",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Un. Fornec.",
          key: "unidade_fornecedor",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Status",
          key: "status",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "Ações",
          key: "acoes",
          tdClass: "text-center",
          thClass: "text-center",
        },
      ],
      produtos_xml: [],
      xml_data: null,
      produtoEditando: null,
      listGrupos: [],
      configuracaoEmpresa: null,
    };
  },
  created() {
    this.currentEmpresa = JSON.parse(localStorage.getItem("currentEmpresa"));
    this.currentUser = JSON.parse(localStorage.getItem("user"));
    this.abrir1 = this.abrir;
    this.produtos_vet = [];
    this.pessoas_vet = [];
    
    console.log('Dados da empresa carregados:', this.currentEmpresa);
    
    // Carrega configuração da empresa do localStorage
    if (this.currentEmpresa && this.currentEmpresa.configuracao) {
      this.configuracaoEmpresa = this.currentEmpresa.configuracao;
      console.log('Configuração da empresa carregada:', this.configuracaoEmpresa);
    } else {
      console.warn('Configuração da empresa não encontrada no localStorage');
      console.log('Estrutura da empresa:', Object.keys(this.currentEmpresa || {}));
    }
  },
  mounted() {
    console.log('Manifesto montado, carregando dados...');
    console.log('Empresa atual:', this.currentEmpresa);
    this.get_arquivos();
    this.carregarGrupos();
  },
  methods: {
    // Método para editar impostos de um produto
    async editarImpostos(produto) {     
      console.log('Iniciando edição de impostos para produto:', produto.cod_fornec);
      
      // Verifica se os grupos estão carregados, se não, carrega novamente
      if (!this.listGrupos || this.listGrupos.length === 0) {
        console.log('Grupos não carregados, carregando...');
        await this.carregarGrupos();
      } else {
        console.log('Grupos já carregados:', this.listGrupos.length, 'itens');
      }
      
      // Valida se os grupos foram carregados com sucesso
      if (!this.listGrupos || this.listGrupos.length === 0) {
        console.error('Falha ao carregar grupos - usando fallback');
        this.usarGruposFallback();
      }
      
      // Aplica grupos padrão se necessário
      this.aplicarGruposPadrao();
      
      // Busca o produto atualizado na lista
      const produtoAtualizado = this.produtos_xml.find(p => p.cod_fornec === produto.cod_fornec);
      this.produtoEditando = produtoAtualizado ? { ...produtoAtualizado } : { ...produto };
      
      console.log('Produto configurado para edição:', this.produtoEditando);
      // O modal será aberto pelo componente edit-tax através da prop visible
    },
    // Método para salvar alterações nos impostos
    salvarImpostos(dados) {
      if (dados && dados.produto) {
        // Encontra o produto na lista e atualiza os dados
        const index = this.produtos_xml.findIndex(p => p.cod_fornec === dados.produto.cod_fornec);
        if (index !== -1) {
          // Atualiza os dados de impostos em memória
          this.produtos_xml[index].dados_xml.icms = { ...dados.dadosImpostos };
          
          // Atualiza o grupo selecionado se fornecido
          if (dados.grupoSelecionado) {
            this.produtos_xml[index].grupo_selecionado = dados.grupoSelecionado;
          }
          
          NotificationService.showAlert("success", "Dados atualizados com sucesso!");
        }
      }

      this.produtoEditando = null;
    },
    // Método para cancelar edição de impostos
    cancelarEdicaoImpostos() {
      this.produtoEditando = null;
    },

    onModalHidden() {
      this.produtoEditando = null;
    },
    // Método para processar arquivo XML
    async handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        if (file.type !== "text/xml" && !file.name.endsWith('.xml')) {
          NotificationService.showAlert("error", "Por favor, selecione um arquivo XML válido");
          return;
        }
        
        NotificationService.showLoading("info", "Processando arquivo XML...");
        await this.processarXML(file);
      }
    },
    // Método para processar XML
    async processarXML(file) {
      try {
        const resultado = await ProdutoManifestoService.processarArquivoXML(
          file,
          this.currentEmpresa,
          this.configuracaoEmpresa
        );
        
        const produtos = resultado.produtos || [];
        const fornecedor = resultado.fornecedor || null;

        if (!Array.isArray(produtos) || !fornecedor) {
          throw new Error("Dados incompletos retornados pelo processamento do XML");
        }

        this.produtos_xml = ProdutoManifestoService.preencherDadosEmpresaPadrao([
          ...produtos,
        ]);
        this.xml_data = { fornecedor };

        const totalExistentes = resultado.produtos_existentes ?? produtos.filter(p => p.status === 'existente').length;
        const totalNovos = resultado.produtos_novos ?? produtos.filter(p => p.status === 'novo').length;
        const mensagem = `${produtos.length} produtos encontrados no XML - ${totalExistentes} existentes, ${totalNovos} novos`;
        NotificationService.showAlert("success", mensagem);
      } catch (error) {
        console.error("Erro ao processar XML:", error);
        NotificationService.showAlert("error", error.message || "Erro ao processar o arquivo XML");
      }
    },

    // Método para processar produtos
    async processarProdutos() {
      if (this.produtos_xml.length === 0) {
        NotificationService.showAlert("warning", "Nenhum produto para processar");
        return;
      }

      try {
        NotificationService.showLoading("info", "Processando produtos...");
        
        // Para cada produto, verifica se já existe na base
        for (let i = 0; i < this.produtos_xml.length; i++) {
          const produto = this.produtos_xml[i];
          
          // Se já foi processado anteriormente e tem relacionamento, pula
          if (produto.status === 'existente' && produto.relacionamento_id) {
            continue;
          }
          
          if (produto.status === 'salvo') {
            continue;
          }
          
          // Se o produto tem código da empresa mas não tem relacionamento, busca na base local
          if (produto.cod_empresa && !produto.relacionamento_id) {
            const produtoExistente = this.produtos_vet.find(p => 
              p.produto_cod_int === produto.cod_empresa
            );
            
            if (produtoExistente) {
              produto.nome_empresa = produtoExistente.produto_nome;
              produto.produto_id = produtoExistente.id;
              produto.fator_conv = produto.fator_conv || "1.00";
              produto.status = "existente";
            } else {
              produto.status = "novo";
              produto.produto_id = null;
            }
          } else if (!produto.cod_empresa) {
            produto.status = "novo";
            produto.produto_id = null;
          }
        }
        
        NotificationService.showAlert("success", "Produtos processados com sucesso!");
      } catch (error) {
        console.error("Erro ao processar produtos:", error);
        NotificationService.showAlert("error", "Erro ao processar produtos: " + error.message);
      }
    },

    // Método para salvar relacionamentos
    async salvarRelacionamentos() {
      if (this.produtos_xml.length === 0) {
        NotificationService.showAlert("warning", "Nenhum produto para salvar");
        return;
      }

      // Avisa sobre produtos novos sem cod_empresa (não bloqueia o processo)
      const produtosNovos = this.produtos_xml.filter(p => p.status === 'novo');
      const produtosNovosSemCodigo = produtosNovos.filter(p => 
        !p.cod_empresa || p.cod_empresa.toString().trim() === ''
      );
      
      if (produtosNovosSemCodigo.length > 0) {
        const produtosNomes = produtosNovosSemCodigo
          .slice(0, 3)
          .map(p => p.dados_xml?.xProd || p.cod_fornec || 'Produto sem nome')
          .join(', ');
        
        const mensagem = produtosNovosSemCodigo.length > 3
          ? `${produtosNovosSemCodigo.length} produtos novos usarão o código do fornecedor como código de barras. Exemplos: ${produtosNomes}...`
          : `Os seguintes produtos novos usarão o código do fornecedor como código de barras: ${produtosNomes}`;
        
        NotificationService.showAlert("warning", mensagem);
      }

      try {
        NotificationService.showLoading("info", "Salvando relacionamentos...");
        
        // Primeiro, verifica se o fornecedor existe na base através da API
        let fornecedorId = null;
        if (this.xml_data && this.xml_data.fornecedor) {
          const fornecedorData = this.xml_data.fornecedor;
          
          // Busca o fornecedor na base por CNPJ através da API
          let fornecedorExistente = null;
          try {
            const response = await PedidoManifestoController.buscarPessoaPorCpfCnpj(fornecedorData.cnpj, this.currentEmpresa.id);
            if (response && response.id) {
              fornecedorExistente = response;
            }
          } catch (error) {
            // Se o erro for 404 (não encontrado), é esperado
            if (error.response && error.response.status === 404) {
              console.log(`Fornecedor com CNPJ ${fornecedorData.cnpj} não encontrado na base - será criado`);
            } else {
              console.log(`Erro ao buscar fornecedor com CNPJ ${fornecedorData.cnpj}:`, error.message);
            }
            // fornecedorExistente permanece null se não encontrar
          }
          
          if (fornecedorExistente) {
            // Fornecedor já existe - carrega os dados
            fornecedorId = fornecedorExistente.id;
            NotificationService.showAlert("info", `Fornecedor encontrado: ${fornecedorExistente.pes_razao || fornecedorExistente.pes_fantasia}`);
          } else {
            // Fornecedor não existe - verifica novamente antes de criar para evitar duplicação
            NotificationService.showLoading("info", `Verificando se fornecedor já foi criado: ${fornecedorData.nome}`);
            
            // Segunda verificação para evitar duplicação em caso de múltiplas execuções
            try {
              const segundaVerificacao = await PedidoManifestoController.buscarPessoaPorCpfCnpj(fornecedorData.cnpj, this.currentEmpresa.id);
              if (segundaVerificacao && segundaVerificacao.id) {
                // Fornecedor foi criado entre as verificações
                fornecedorId = segundaVerificacao.id;
                NotificationService.showAlert("info", `Fornecedor já existe: ${segundaVerificacao.pes_razao || segundaVerificacao.pes_fantasia}`);
                console.log("Fornecedor encontrado na segunda verificação:", segundaVerificacao);
              } else {
                throw new Error('Fornecedor não encontrado, prosseguindo com criação');
              }
            } catch (segundaVerificacaoError) {
              // Realmente não existe, pode criar
              NotificationService.showLoading("info", `Criando novo fornecedor: ${fornecedorData.nome}`);
              
              try {
              // Busca o código do estado no array de estados
              let estadoId = null;
              if (fornecedorData.endereco.uf) {
                const estadoEncontrado = listEstados.find(estado => 
                  estado.uf === fornecedorData.endereco.uf
                );
                if (estadoEncontrado) {
                  estadoId = estadoEncontrado.id;
                  console.log(`Código do estado ${fornecedorData.endereco.uf}: ${estadoId}`);
                } else {
                  console.warn(`Não foi possível obter código do estado ${fornecedorData.endereco.uf}`);
                  // Usa código padrão para estado não encontrado
                  estadoId = 35; // São Paulo como padrão
                }
              } else {
                estadoId = 35; // São Paulo como padrão
              }
              
              const novoFornecedor = {
                pes_cpfcnpj: fornecedorData.cnpj,
                pes_razao: fornecedorData.nome,
                pes_fantasia: fornecedorData.fantasia || fornecedorData.nome,
                pes_apelido: fornecedorData.fantasia || fornecedorData.nome, // Preenche com xFant do XML
                pes_ie: fornecedorData.ie || "",
                pes_im: fornecedorData.im || "",
                pes_endereco: fornecedorData.endereco.logradouro || "",
                pes_numero: fornecedorData.endereco.numero || "",
                pes_complemento: fornecedorData.endereco.complemento || "",
                pes_bairro: fornecedorData.endereco.bairro || "",
                pes_cidade: fornecedorData.endereco.cidade_nome || "",
                pes_uf: fornecedorData.endereco.uf || "",
                pes_pais: fornecedorData.endereco.pais_nome || "BRASIL",
                pes_cep: fornecedorData.endereco.cep || "",
                pes_fornecedor: -2, // Marca como fornecedor (conforme solicitado)
                ativo: 1,
                // Campos obrigatórios
                cidade_id: fornecedorData.endereco.cidade_codigo || null,
                estado_id: estadoId,
                pais_id: 1058, // Brasil (código fixo)
                pes_filialid: this.currentEmpresa.id, // ID da empresa logada
                empresa_id: this.currentEmpresa.id // Empresa logada
              };
              
              console.log("Criando fornecedor com os dados:", novoFornecedor);
              
              const fornecedorCriado = await PedidoManifestoController.createPessoa(novoFornecedor);
              fornecedorId = fornecedorCriado.id;
              
              // Atualiza a lista de pessoas para incluir o novo fornecedor
              this.pessoas_vet = await PessoaController.getPessoas();
              
              NotificationService.showAlert("success", `Fornecedor criado com sucesso: ${fornecedorData.nome} (ID: ${fornecedorId})`);
              
              } catch (error) {
                console.error("Erro ao criar fornecedor:", error);
                NotificationService.showAlert("error", "Erro ao criar fornecedor: " + error.message);
                return;
              }
            }
          }
        }
        
        if (!fornecedorId) {
          NotificationService.showAlert("error", "Fornecedor não identificado");
          return;
        }
        
        // Filtra produtos que podem ser salvos
        const produtosParaSalvar = this.produtos_xml.filter(p => 
          p.cod_fornec && p.nome_fornecedor
        );
        
        if (produtosParaSalvar.length === 0) {
          NotificationService.showAlert("warning", "Nenhum produto com dados completos para salvar");
          return;
        }
        
        // Prepara dados para criação de produtos e relacionamentos
        const produtosParaCriar = [];
        const relacionamentos = [];
        
        // Processa cada produto do XML seguindo a nova regra
        for (const produto of produtosParaSalvar) {
          console.log(`Processando produto: ${produto.cod_fornec} - ${produto.dados_xml.xProd}`);
          
          // 1. Verifica se já existe relacionamento (fornecedor + cProd + xProd)
          const relacionamentoExistente = await this.verificarRelacionamentoExistente(
            produto.cod_fornec, 
            produto.dados_xml.xProd, 
            this.currentEmpresa.id,
            fornecedorId // Envia pessoa_id quando disponível para busca mais específica
          );
          
          if (relacionamentoExistente) {
            // Relacionamento já existe - usa o produto existente
            console.log(`Relacionamento existente encontrado para ${produto.cod_fornec} - ${produto.dados_xml.xProd}`);
            produto.produto_id = relacionamentoExistente.produto_id;
            produto.status = "existente";
            produto.cod_empresa = relacionamentoExistente.produto?.produto_cod_int || "";
            produto.nome_empresa = relacionamentoExistente.produto?.produto_nome || produto.dados_xml.xProd;
            
            // Adiciona ao array de relacionamentos existentes
            relacionamentos.push({
              produto_id: relacionamentoExistente.produto_id,
              pessoa_id: fornecedorId,
              cod_externo: produto.cod_fornec,
              fornecedor_descricao: produto.dados_xml.xProd,
              empresa_id: this.currentEmpresa.id,
              fornecedor_um: produto.unidade_fornecedor || "",
              fornecedor_fator: parseFloat(produto.fator_conv) || 1.0,
              relacionamento_existente: true // Flag para indicar que já existe
            });
            continue; // Pula para o próximo produto
          }
          
          // 2. Relacionamento não existe - precisa criar produto e relacionamento
          console.log(`Novo relacionamento necessário para ${produto.cod_fornec} - ${produto.dados_xml.xProd}`);
          
          // Define o grupo_id baseado na seleção do usuário ou grupo_id do produto
          let grupoId = null;
          
          if (produto.grupo_selecionado && produto.grupo_selecionado.id) {
            // Prioridade 1: Grupo selecionado pelo usuário no modal
            grupoId = produto.grupo_selecionado.id;
            console.log('Usando grupo selecionado pelo usuário:', grupoId);
          } else if (produto.grupo_id) {
            // Prioridade 2: Grupo definido no processamento do XML
            grupoId = produto.grupo_id;
            console.log('Usando grupo_id do processamento XML:', grupoId);
          } else {
            console.warn('Nenhum grupo_id encontrado - produto será criado sem grupo');
          }
          
          // Usa nome_empresa se fornecido pelo usuário, senão usa xProd do XML
          const nomeProduto = produto.nome_empresa || produto.dados_xml.xProd;
          
          // Valida se cod_empresa está preenchido (obrigatório para codbarras)
          const codbarras = produto.cod_empresa && produto.cod_empresa.trim() !== '' 
            ? produto.cod_empresa.trim() 
            : produto.cod_fornec;
          
          const novoProduto = {
            codbarras: codbarras,
            produto_nome: nomeProduto,
            produto_descricao: nomeProduto,
            um: produto.dados_xml.uCom,
            preco_custo: parseFloat(produto.dados_xml.vUnCom) || 0,
            preco: parseFloat(produto.dados_xml.vUnCom) || 0,
            preco_atacado: parseFloat(produto.dados_xml.vUnCom) || 0,
            produto_ncm: produto.dados_xml.ncm || "",
            produto_picms: parseFloat(produto.dados_xml.icms.picms) || 0,
            produto_cst: produto.dados_xml.icms.cst || "00",
            produto_cstpis: produto.dados_xml.icms.cstpis || "00",
            produto_cstcofins: produto.dados_xml.icms.cstcofins || "00",
            produto_orig: produto.dados_xml.icms.orig || "0",
            produto_cfop: produto.dados_xml.cfop || "",
            // Campos obrigatórios adicionais
            produto_cest: produto.dados_xml.icms.cest || "0",
            produto_class_sped: produto.dados_xml.icms.class_sped || "00",
            produto_cstipi: produto.dados_xml.icms.cstipi || "00",
            produto_pbc_pis: parseFloat(produto.dados_xml.icms.pbc_pis) || 100,
            produto_pbc_cofins: parseFloat(produto.dados_xml.icms.pbc_cofins) || 100,
            produto_pbc_icms: parseFloat(produto.dados_xml.icms.pbc_icms) || 100,
            produto_pbc_ipi: parseFloat(produto.dados_xml.icms.pbc_ipi) || 100,
            produto_pcofins: parseFloat(produto.dados_xml.icms.pcofins) || 100,
            produto_ppis: parseFloat(produto.dados_xml.icms.ppis) || 100,
            produto_pipi: parseFloat(produto.dados_xml.icms.pipi) || 100,
            ativo: 1,
            grupo_id: grupoId,
            empresa_id: this.currentEmpresa.id,
            produto_fatexport: 1,
            produto_estminimo: 1,
            // Campos obrigatórios com valores padrão
            unidade_id: 1,
            idtipo: 1,
            qtd: 0,
            produto_finalidade: 1,
            produto_margemlucro: 0,
            produto_m_s: "M",
            produto_controla_estoque: 1,
            produto_balanca: 0,
            produto_produzido: 0,
            produto_materiaprima: 0,
            // Identificador temporário para vincular com relacionamento
            temp_identifier: `${produto.cod_fornec}||${produto.dados_xml.xProd}`
          };
          
          produtosParaCriar.push(novoProduto);
          
          // Cria estrutura do relacionamento
          const novoRelacionamento = {
            produto_id: 'PENDENTE', // Será atualizado após criar o produto
            pessoa_id: fornecedorId,
            cod_externo: produto.cod_fornec,
            fornecedor_descricao: produto.dados_xml.xProd, // Sempre usa xProd do XML
            // Importante: envia o nome_empresa para que o backend reutilize o produto pelo nome correto
            nome_empresa: nomeProduto,
            empresa_id: this.currentEmpresa.id,
            fornecedor_um: produto.unidade_fornecedor || "",
            fornecedor_fator: parseFloat(produto.fator_conv) || 1.0,
            // Identificador temporário para vincular com produto
            temp_identifier: `${produto.cod_fornec}||${produto.dados_xml.xProd}`
          };
          
          relacionamentos.push(novoRelacionamento);
        }
        
        // Cria produtos novos se necessário
        if (produtosParaCriar.length > 0) {
          NotificationService.showLoading("info", `Criando ${produtosParaCriar.length} novos produtos...`);
          
          try {
            const produtosCriados = await PedidoManifestoController.createProdutosBatch(produtosParaCriar);
            
            if (produtosCriados.created && produtosCriados.created.length > 0) {
              NotificationService.showAlert("success", `${produtosCriados.created.length} produtos criados com sucesso!`);
              
              // Atualiza a lista de produtos da empresa
              this.produtos_vet = await ProdutoController.getProdutos(this.currentEmpresa.id);
              
              // Atualiza os IDs dos produtos nos relacionamentos usando codbarras (método confiável)
              console.log('Atualizando produto_id nos relacionamentos...');
              console.log('Produtos criados:', produtosCriados.created);
              console.log('Relacionamentos antes da atualização:', relacionamentos);
              
              // Cria mapa de produtos da empresa por codbarras (mais robusto que depender do payload do POST)
              const mapaEmpresaPorCodbarras = new Map();
              for (const pEmp of (this.produtos_vet || [])) {
                if (pEmp && pEmp.codbarras) {
                  mapaEmpresaPorCodbarras.set(String(pEmp.codbarras).trim(), pEmp);
                }
              }

              // Vincula produto_id nos relacionamentos usando o codbarras utilizado para criação, resolvendo contra a base atual
              for (const relacionamento of relacionamentos) {
                if (relacionamento.produto_id === 'PENDENTE') {
                  // Recalcula o codbarras esperado com a mesma regra de criação
                  const prodRef = produtosParaSalvar.find(p => `${p.cod_fornec}||${p.dados_xml.xProd}` === relacionamento.temp_identifier);
                  const codbarrasEsperado = prodRef && prodRef.cod_empresa && prodRef.cod_empresa.trim() !== ''
                    ? prodRef.cod_empresa.trim()
                    : (prodRef ? prodRef.cod_fornec : '');
                  const produtoCriado = mapaEmpresaPorCodbarras.get(String(codbarrasEsperado).trim());
                  if (produtoCriado) {
                    relacionamento.produto_id = produtoCriado.id;
                    console.log(`Relacionamento ${relacionamento.cod_externo} vinculado ao produto ${produtoCriado.id} via codbarras ${codbarrasEsperado}`);
                  } else {
                    console.warn(`Produto não encontrado por codbarras (${codbarrasEsperado}) para relacionamento ${relacionamento.temp_identifier}`);
                  }
                }
              }
            }
            
            if (produtosCriados.errors && produtosCriados.errors.length > 0) {
              NotificationService.showAlert("warning", `${produtosCriados.errors.length} produtos não puderam ser criados`);
              console.log("Erros na criação de produtos:", produtosCriados.errors);
            }
            
          } catch (error) {
            console.error("Erro ao criar produtos:", error);
            NotificationService.showAlert("error", "Erro ao criar produtos: " + error.message);
            return;
          }
        }
        
        // Filtra relacionamentos válidos (com produto_id) e remove duplicados
        const relacionamentosValidos = relacionamentos.filter(r => r.produto_id);
        
        // Remove relacionamentos que já existem (marcados com flag)
        const relacionamentosParaCriar = relacionamentosValidos.filter(r => !r.relacionamento_existente);
        
        if (relacionamentosParaCriar.length === 0) {
          // Verifica se existem relacionamentos válidos mas já existentes
          const relacionamentosExistentes = relacionamentosValidos.filter(r => r.relacionamento_existente);
          if (relacionamentosExistentes.length > 0) {
            NotificationService.showAlert("info", `${relacionamentosExistentes.length} relacionamentos já existem na base`);
            
            // Atualiza o status dos produtos existentes
            for (let i = 0; i < this.produtos_xml.length; i++) {
              const produto = this.produtos_xml[i];
              const relacionamentoEncontrado = relacionamentosExistentes.find(r => r.cod_externo === produto.cod_fornec);
              if (relacionamentoEncontrado) {
                this.produtos_xml[i].status = "salvo";
              }
            }
            
            NotificationService.showAlert("success", "Processo concluído - todos os relacionamentos já existiam!");
            return;
          } else {
            NotificationService.showAlert("warning", "Nenhum relacionamento válido para salvar");
            return;
          }
        }
        
        // Cria os relacionamentos na tabela int_produto_fornecedor
        NotificationService.showLoading("info", `Criando ${relacionamentosParaCriar.length} relacionamentos...`);
        
        try {
          const relacionamentosCriados = await PedidoManifestoController.createRelacionamentosBatch(
            this.currentEmpresa.id,
            relacionamentosParaCriar
          );
          
          if (relacionamentosCriados.created && relacionamentosCriados.created.length > 0) {
            NotificationService.showAlert("success", `${relacionamentosCriados.created.length} relacionamentos criados com sucesso!`);
            
            // Atualiza o status dos produtos criados
            for (let i = 0; i < this.produtos_xml.length; i++) {
              const produto = this.produtos_xml[i];
              const relacionamentoEncontrado = relacionamentosParaCriar.find(r => r.cod_externo === produto.cod_fornec);
              if (relacionamentoEncontrado) {
                this.produtos_xml[i].status = "salvo";
                // Busca o relacionamento criado para obter o ID
                const relacionamentoCriado = relacionamentosCriados.created.find(rc => 
                  rc.cod_externo === produto.cod_fornec && rc.fornecedor_descricao === produto.dados_xml.xProd
                );
                if (relacionamentoCriado) {
                  this.produtos_xml[i].relacionamento_id = relacionamentoCriado.id;
                }
              }
            }
          }
          
          if (relacionamentosCriados.errors && relacionamentosCriados.errors.length > 0) {
            NotificationService.showAlert("warning", `${relacionamentosCriados.errors.length} relacionamentos não puderam ser criados`);
            console.log("Erros na criação de relacionamentos:", relacionamentosCriados.errors);
          }
          
        } catch (error) {
          console.error("Erro ao criar relacionamentos:", error);
          NotificationService.showAlert("error", "Erro ao criar relacionamentos: " + error.message);
          return;
        }
        
        NotificationService.showAlert("success", "Processo concluído com sucesso!");
        
      } catch (error) {
        console.error("Erro ao salvar relacionamentos:", error);
        NotificationService.showAlert("error", "Erro ao salvar relacionamentos: " + error.message);
      }
    },

    // Método para limpar produtos
    limparProdutos() {
      this.produtos_xml = [];
      this.xml_data = null;
      this.produtoEditando = null;
      NotificationService.showAlert("success", "Produtos limpos com sucesso");
    },



    // Método para obter produtos por status
    getProdutosPorStatus(status) {
      return this.produtos_xml.filter(p => p.status === status);
    },

    // Método para obter variante do status
    getStatusVariant(status) {
      switch (status) {
        case 'existente': return 'success';
        case 'novo': return 'warning';
        case 'salvo': return 'info';
        default: return 'secondary';
      }
    },

    // Método para obter texto do status
    getStatusText(status) {
      switch (status) {
        case 'existente': return '🟢 Existente';
        case 'novo': return '🟡 Novo';
        case 'salvo': return '🔵 Salvo';
        default: return '⚪ Desconhecido';
      }
    },

    // Método para obter título do status
    getStatusTitle(status) {
      switch (status) {
        case 'existente': return 'Produto já relacionado na base';
        case 'novo': return 'Produto novo que será criado';
        case 'salvo': return 'Relacionamento salvo com sucesso';
        default: return 'Status desconhecido';
      }
    },

    // Método para selecionar arquivo
    selecionarArquivo() {
      document.getElementById('fileInput').click();
    },

    // Método para carregar grupos
    async carregarGrupos() {
      if (!this.currentEmpresa || !this.currentEmpresa.id) {
        console.error('Empresa não definida, não é possível carregar grupos');
        return;
      }

      try {
        console.log('Carregando grupos para empresa:', this.currentEmpresa.id);
        
        const grupos = await PedidoManifestoController.getGrupos(this.currentEmpresa.id);
        console.log('Resposta da API de grupos:', grupos);
        
        if (grupos && Array.isArray(grupos)) {
          this.listGrupos = grupos.map((item) => {
            return {
              name: item.descricaogrupo,
              id: item.id,
            };
          });
          
          console.log('Grupos carregados:', this.listGrupos);
        } else {
          console.warn('Resposta da API não é um array:', grupos);
          this.usarGruposFallback();
        }
      } catch (error) {
        console.error('Erro ao carregar grupos:', error);
        this.usarGruposFallback();
      }
    },

    // Método para aplicar grupos padrão para produtos que não tiveram grupo definido
    aplicarGruposPadrao() {
      console.log('Aplicando grupos padrão para produtos sem grupo_id...');
      
      this.produtos_xml.forEach((produto, index) => {
        if (!produto.grupo_id) {
          console.log(`Produto ${produto.cod_fornec} não tem grupo_id, aplicando agora...`);
          
          if (produto.status === "existente" && produto.produto_dados && produto.produto_dados.grupo_id) {
            // Produto já existe - usa o grupo_id do produto existente
            this.produtos_xml[index].grupo_id = produto.produto_dados.grupo_id;
            console.log(`Aplicado grupo_id do produto existente: ${produto.produto_dados.grupo_id}`);
          } else if (produto.status === "novo" && this.configuracaoEmpresa && this.configuracaoEmpresa.grupo_id) {
            // Produto novo - usa grupo_id da configuração da empresa
            this.produtos_xml[index].grupo_id = this.configuracaoEmpresa.grupo_id;
            console.log(`Aplicado grupo_id da configuração: ${this.configuracaoEmpresa.grupo_id}`);
          } else {
            console.warn(`Não foi possível definir grupo para produto ${produto.cod_fornec}`);
          }
        } else {
          console.log(`Produto ${produto.cod_fornec} já tem grupo_id: ${produto.grupo_id}`);
        }
      });
    },

    // Método auxiliar para usar grupos de fallback
    usarGruposFallback() {
      // Fallback: tenta carregar do localStorage se disponível
      if (this.currentEmpresa && this.currentEmpresa.grupos) {
        console.log('Usando grupos do localStorage:', this.currentEmpresa.grupos);
        this.listGrupos = this.currentEmpresa.grupos.map((item) => {
          return {
            name: item.descricaogrupo,
            id: item.id,
          };
        });
      } else {
        console.warn('Nenhum grupo encontrado no localStorage');
        // Fallback final: criar um grupo padrão para teste
        this.listGrupos = [
          {
            id: 1,
            name: 'Grupo Padrão'
          }
        ];
        console.log('Usando grupo padrão de teste:', this.listGrupos);
      }
    },


    // Método para obter arquivos (placeholder)
    get_arquivos() {
      // Implementação placeholder
      console.log("Obtendo arquivos...");
    },

    // Método para verificar se relacionamento já existe
    async verificarRelacionamentoExistente(codExterno, fornecedorDescricao, empresaId, pessoaId = null) {
      try {
        const cod = String(codExterno || '').trim();
        const descRaw = String(fornecedorDescricao || '').trim();
        const descCollapsed = descRaw.replace(/\s+/g, ' ').trim();
        const descNoAccents = descCollapsed.normalize('NFD').replace(/\p{Diacritic}/gu, '');

        const tentativas = [descRaw, descCollapsed, descNoAccents];

        for (const tentativa of tentativas) {
          const resp = await PedidoManifestoController.buscarRelacionamento(
            empresaId,
            cod,
            tentativa,
            pessoaId // Passa pessoa_id quando disponível
          );

          if (!resp) continue;

          // Formato 1: { success: true, produto: { ... } }
          if (resp.success && resp.produto) {
            return resp.produto;
          }
          // Formato 2: { success: true, data: { ... } }
          if (resp.success && resp.data) {
            return resp.data;
          }
          // Formato 3: objeto direto
          if (resp.produto_id || resp.cod_externo) {
            return resp;
          }
        }

        return null;
      } catch (error) {
        if (error.response && error.response.status === 404) {
          return null;
        }
        console.warn(`Erro ao verificar relacionamento ${codExterno}:`, error.message);
        return null;
      }
    }
  }
};
</script>

<style scoped>
.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.btn {
  margin-right: 0.5rem;
}

.badge {
  font-size: 0.875em;
}

.table th {
  background-color: #f8f9fa;
  border-top: none;
}

.form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
</style>
